import { ChevronDown, ChevronUp, Plus, Trash2 } from "lucide-react";
import BlockFieldsEditor from "./BlockFieldsEditor";
import { defaultItemForFields } from "./fieldDefaults";

function moveItem(items, index, direction) {
  const target = index + direction;
  if (target < 0 || target >= items.length) return items;
  const next = [...items];
  [next[index], next[target]] = [next[target], next[index]];
  return next;
}

/** Add/remove/reorder editor for a "list" field — used both for top-level
 * repeatable content (e.g. Why Book's reasons) and could nest further if a
 * future block needs it. No drag-and-drop library is installed, so
 * reordering is plain move-up/move-down buttons. */
export default function RepeatableListField({
  itemLabel = "Item",
  itemFields,
  items = [],
  onChange,
  onUploadImage,
}) {
  const updateItem = (index, key, value) => {
    const next = items.map((item, i) =>
      i === index ? { ...item, [key]: value } : item,
    );
    onChange(next);
  };

  const removeItem = (index) => {
    onChange(items.filter((_, i) => i !== index));
  };

  const addItem = () => {
    onChange([...items, defaultItemForFields(itemFields)]);
  };

  return (
    <div className="space-y-3">
      {items.map((item, index) => (
        <div
          key={index}
          className="rounded-xl border border-gray-200 bg-gray-50 p-4"
        >
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">
              {itemLabel} {index + 1}
            </span>
            <div className="flex items-center gap-1">
              <button
                type="button"
                onClick={() => onChange(moveItem(items, index, -1))}
                disabled={index === 0}
                className="h-7 w-7 rounded-lg border border-gray-200 bg-white flex items-center justify-center text-gray-500 hover:bg-gray-100 disabled:opacity-30"
              >
                <ChevronUp className="h-3.5 w-3.5" />
              </button>
              <button
                type="button"
                onClick={() => onChange(moveItem(items, index, 1))}
                disabled={index === items.length - 1}
                className="h-7 w-7 rounded-lg border border-gray-200 bg-white flex items-center justify-center text-gray-500 hover:bg-gray-100 disabled:opacity-30"
              >
                <ChevronDown className="h-3.5 w-3.5" />
              </button>
              <button
                type="button"
                onClick={() => removeItem(index)}
                className="h-7 w-7 rounded-lg border border-red-200 bg-white flex items-center justify-center text-red-500 hover:bg-red-50"
              >
                <Trash2 className="h-3.5 w-3.5" />
              </button>
            </div>
          </div>

          <BlockFieldsEditor
            schema={itemFields}
            values={item}
            onChange={(key, value) => updateItem(index, key, value)}
            onUploadImage={onUploadImage}
          />
        </div>
      ))}

      <button
        type="button"
        onClick={addItem}
        className="w-full h-10 rounded-xl border border-dashed border-gray-300 text-sm font-semibold text-gray-500 hover:bg-gray-50 flex items-center justify-center gap-1.5"
      >
        <Plus className="h-4 w-4" />
        Add {itemLabel}
      </button>
    </div>
  );
}
